function BankNoteIcon({ className }) {
  return (
    <svg
      className={`ic ${className}`}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.12"
        d="M15.9998 19.3333C17.8408 19.3333 19.3332 17.841 19.3332 16C19.3332 14.1591 17.8408 12.6667 15.9998 12.6667C14.1589 12.6667 12.6665 14.1591 12.6665 16C12.6665 17.841 14.1589 19.3333 15.9998 19.3333Z"
        fill="currentColor"
      />
      <path
        d="M7.99984 14.6667V20M23.9998 12V17.3333M22.6665 5.33333C25.9314 5.33333 27.6973 5.83301 28.576 6.22058C28.693 6.2722 28.7515 6.29801 28.9204 6.45916C29.0216 6.55575 29.2063 6.83919 29.2539 6.97078C29.3332 7.19031 29.3332 7.31031 29.3332 7.55032V21.8815C29.3332 23.0932 29.3332 23.6991 29.1515 24.0105C28.9666 24.3272 28.7884 24.4745 28.4424 24.5962C28.1023 24.7159 27.4158 24.584 26.0427 24.3202C25.0817 24.1355 23.9419 24 22.6665 24C18.6665 24 14.6665 26.6667 9.33317 26.6667C6.06823 26.6667 4.30233 26.167 3.42368 25.7794C3.30667 25.7278 3.24816 25.702 3.0793 25.5408C2.97809 25.4442 2.79333 25.1608 2.7458 25.0292C2.6665 24.8097 2.6665 24.6897 2.6665 24.4497L2.6665 10.1185C2.6665 8.90678 2.6665 8.30093 2.84821 7.98952C3.03304 7.67275 3.21129 7.52548 3.55725 7.40374C3.89735 7.28406 4.58388 7.41597 5.95694 7.67979C6.91799 7.86445 8.05781 7.99999 9.33317 7.99999C13.3332 7.99999 17.3332 5.33333 22.6665 5.33333ZM19.3332 16C19.3332 17.8409 17.8408 19.3333 15.9998 19.3333C14.1589 19.3333 12.6665 17.8409 12.6665 16C12.6665 14.159 14.1589 12.6667 15.9998 12.6667C17.8408 12.6667 19.3332 14.159 19.3332 16Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BankNoteIcon;
